
    import I18n from 'i18nObj';
    
      import 'translations/quizzes_index';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('quizzes_index');
  